import { Instagram, Mail } from "lucide-react";
import { scrollToId } from "../lib/lenis";
import { LOGO_URL } from "../data";

export const Footer = () => (
  <footer className="footer" data-testid="site-footer">
    <div className="footer-inner">
      <div className="footer-brand">
        <button className="brand" onClick={() => scrollToId("top")} data-testid="footer-brand-home">
          <img className="brand-logo logo-mono" src={LOGO_URL} alt="Vanguard Marketing Digital" />
          <span className="brand-word"><strong>VANGUARD</strong><small>MARKETING DIGITAL</small></span>
        </button>
        <p>Construindo o próximo capítulo<br />de marcas ambiciosas.</p>
      </div>
      <div className="footer-links">
        <a href="mailto:contato@vanguardmarketing.com.br" data-testid="footer-email"><Mail size={14} /> contato@vanguardmarketing.com.br</a>
        <a href="https://instagram.com/vanguardmarketing" target="_blank" rel="noreferrer" data-testid="footer-instagram"><Instagram size={14} /> @vanguardmarketing</a>
      </div>
    </div>
    <div className="footer-bottom">
      <span>© 2026 Vanguard Marketing Digital</span>
      <span>Feito para marcas que querem crescer</span>
    </div>
  </footer>
);
